import { useCallback, useMemo } from 'react';
import axios from 'axios';
import { useAuth } from '../../../context/AuthContext';

const API = `${process.env.REACT_APP_BACKEND_URL}/api/hiring`;

export const useHiringApi = () => {
  const { token } = useAuth();
  const call = useCallback(async (method, path, data, config = {}) => {
    const res = await axios({ method, url: `${API}${path}`, data, headers: { Authorization: `Bearer ${token}` }, ...config });
    return res.data;
  }, [token]);
  return useMemo(() => ({
    config: () => call('get', '/config'),
    stats: () => call('get', '/stats'),
    list: (params) => call('get', `/applicants?${new URLSearchParams(Object.fromEntries(Object.entries(params).filter(([, v]) => v)))}`),
    get: (id) => call('get', `/applicants/${id}`),
    addManual: (body) => call('post', '/applicants', body),
    assign: (id, body) => call('patch', `/applicants/${id}`, body),
    stage: (id, stage, reason) => call('post', `/applicants/${id}/stage`, { stage, reason }),
    note: (id, body, kind = 'note') => call('post', `/applicants/${id}/notes`, { body, kind }),
    addInterview: (id, body) => call('post', `/applicants/${id}/interviews`, body),
    updateInterview: (id, iid, body) => call('patch', `/applicants/${id}/interviews/${iid}`, body),
    trial: (id, body) => call('put', `/applicants/${id}/trial-clean`, body),
    offer: (id, body) => call('put', `/applicants/${id}/offer`, body),
    decision: (id, body) => call('put', `/applicants/${id}/decision`, body),
    message: (id, body) => call('post', `/applicants/${id}/messages`, body),
    convert: (id, body) => call('post', `/applicants/${id}/convert-to-guru`, body),
    resumeBlob: (id) => call('get', `/applicants/${id}/resume`, undefined, { responseType: 'blob' }),
  }), [call]);
};

export const errMsg = (e, fallback = 'Something went wrong') => {
  const d = e?.response?.data?.detail;
  if (!d) return fallback;
  if (typeof d === 'string') return d;
  return d.message || d.code || JSON.stringify(d);
};
